<template>
  <div class="goods meeting">
    <v-head :title="title"></v-head>
    <div class="voteBox">
      <div class="voteDiv">
        <h4>{{ electionRelease.name }}</h4>
        <div class="butBox">
          <!-- <div>
            <van-button type="primary" size="mini">多选</van-button>
            <van-button type="danger" size="mini">绝对多数复选制</van-button>
          </div> -->
          <b
            >已参与人数：{{
              electionRelease.visitors ? electionRelease.visitors : 0
            }}人</b
          >
        </div>
        <div class="introduce">
          <p class="m-content overflow-line" id="J_description">
            {{ electionRelease.content }}
          </p>
          <div
            class="btn-more"
            v-if="isShowMore"
            id="J_btnmore"
            @click="showmoreDesc($event)"
          >
            展开查看更多
          </div>
        </div>
      </div>
      <p class="timeDjs">投票倒计时：{{ countDown }}</p>
      <van-divider>投票列表</van-divider>
      <div class="listRodio">
        <p>注：最少可选 {{ minTimes }} 项，最多可选 {{ maxTimes }}项</p>
        <van-checkbox-group v-model="result" :max="maxTimes">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in candidateList"
              clickable
              :key="item.id"
              :title="item.contentType == 1 ? item.name : item.content"
              @click="toggle(index)"
            >
              <template #right-icon>
                <van-checkbox :name="item.id" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
      <van-button :disabled="disabledBut" type="primary" block @click="submit()"
        >提交</van-button
      >
    </div>

    <van-dialog
      v-model="show"
      title="查询指定人"
      show-cancel-button
      :before-close="beforeClose"
    >
      <van-form @submit="onSubmit">
        <van-field
          v-model="vote.name"
          name="姓名"
          label="姓名"
          required
          placeholder="请输入姓名"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="vote.mobile"
          name="手机号"
          label="手机号"
          required
          placeholder="请输入手机号"
          :rules="[{ required: true }]"
        />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import vHead from "../../components/Subhead.vue";
import {
  Button,
  Divider,
  List,
  CountDown,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Toast,
  Dialog,
  Form,
  Field,
} from "vant";
import { mapGetters, mapState, mapActions } from "vuex";
import {
  getUser,
  getCandidateList,
  voteInfoSave,
  getElectionReleaseInfo,
  voteInfoTimes,
  getElectionVote,
} from "@/api/dictionary";
import { getSessionStore } from "@/utils/sessionStorage.js";
import { param } from "../../static/jquery-1.10.2";
export default {
  data() {
    return {
      isShowMore: false,
      isDescStatus: true,
      countDown: null,
      navActive: 3,
      page: -1,
      title: "投票",
      show: false,
      result: [],
      candidateList: [],
      minTimes: 1,
      maxTimes: 1,
      voteInfoTimesNum: "",
      vote: {
        name: "",
        mobile: "",
      },
      electionRelease: {
        name: "",
        startTime: null,
        endTime: null,
        times: null,
        minTimes: null,
        maxTimes: null,
        visitors: null,
        contentType: null,
        isVote: null,
        type: null,
      },
      disabledBut: false,
    };
  },
  components: {
    vHead,
    [Button.name]: Button,
    [Divider.name]: Divider,
    [List.name]: List,
    [CountDown.name]: CountDown,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Toast.name]: Toast,
    [Form.name]: Form,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
  },
  methods: {
    ...mapActions(["getGroupMemberType", "getPersonMemberType"]),
    goPath(pathName) {
      this.$router.push({ name: pathName });
    },
    changActive(val) {
      this.navActive = val;
    },
    beforeClose: function(action, done) {
      // 点击事件 - 备注按钮提示框
      if (action === "confirm") {
        getElectionVote(this.vote).then((res) => {
          if (res.success) {
            let params = {
              ids: this.result.join(","),
              memberId: res.result.id,
            };
            this.voteInfoSave(params);
          } else {
            Toast("暂无投票权限");
            this.vote.name = "";
            this.vote.mobile = "";
            done(); // 关闭提示框
          }
        });
      } else if (action === "cancel") {
        this.vote.name = "";
        this.vote.mobile = "";
        done(); // 关闭提示框
      }
    },
    onSubmit(values) {
      console.log("submit", values);
    },
    showmoreDesc(e) {
      let el = e.currentTarget;
      el.previousElementSibling.classList[
        !this.isDescStatus ? "add" : "remove"
      ]("overflow-line");
      el.classList[this.isDescStatus ? "add" : "remove"]("more-collapse");
      el.innerHTML = !this.isDescStatus ? "展开查看更多" : "收起";
      this.isDescStatus = !this.isDescStatus;
      this.isShowMore = true;
    },
    toggle(index) {
      if (this.voteInfoTimesNum >= 1) {
        Toast.fail("您的投票次数用完了!");
        this.maxTimes == 0;
        return;
      }
      this.$refs.checkboxes[index].toggle();
      if (index + 1 > this.maxTimes) {
        Toast("最少可选" + this.minTimes + ",最多可选" + this.maxTimes);
      }
    },
    submit() {
      let times = this.result.length;
      //如果是单选 只能选择一个
      //判断可选的数量  最少数量和最多数量
      if (this.electionRelease.type == 1) {
        if (times != 1) {
          Toast("最少可选" + this.minTimes + ",最多可选" + this.maxTimes);
          return;
        }
      }

      if (times > this.maxTimes || times < this.minTimes) {
        Toast("最少可选" + this.minTimes + ",做多可选" + this.maxTimes);
        return;
      }

      if (this.electionRelease.endTime) {
        var aaa = new Date(
          this.electionRelease.endTime.replace(/-/g, "/")
        ).getTime();
        var bbb = new Date().getTime();
        let startTime = new Date(
          this.electionRelease.startTime.replace(/-/g, "/")
        ).getTime();
        if (startTime > bbb) {
          Toast.fail("投票还未开始");
          return;
        }
        if (aaa < bbb) {
          Toast.fail("投票结束");
          return;
        }
      }
      let params = {
        ids: this.result.join(","),
      };
      //如果是指定人 2 判断指定人信息
      //如果是所有人1，则需要登录
      if (this.electionRelease.visibleRange == 1) {
        params.memberId = getSessionStore("memberId");
        this.voteInfoSave(params);
      } else {
        this.show = true;
      }
    },
    voteInfoSave(params) {
      //投票人信息
      //ids是被投票信息
      voteInfoSave(params).then((res) => {
        if (res.success) {
          Toast.success("投票成功");
          //跳转页面，根据投票设置，如果需要展示投票结果
          if (this.electionRelease.isVote == 1) {
            this.$router.push({
              name: "vote",
            });
          } else {
            this.$router.push({
              path: "/voteResult",
              query: {
                id: this.electionRelease.id,
                visitors: this.electionRelease.visitors,
                visibleRange: this.electionRelease.visibleRange,
              },
            });
          }
        } else {
          Toast.fail("投票失败");
        }
      });
    },
    voteInfoTimesData() {
      let params = {
        electionId: this.electionRelease.id,
      };
      if (this.electionRelease.visibleRange == 1) {
        params.memberId = getSessionStore("memberId");
      } else {
        params.memberId = this.memberId;
      }
      voteInfoTimes(params).then((res) => {
        if (res.success) {
          if (this.electionRelease.times == 1) {
            this.voteInfoTimesNum = res.result.totalTimes;
          } else {
            this.voteInfoTimesNum = res.result.dayTimes;
          }
          if (this.voteInfoTimesNum >= 1) {
            this.disabledBut = true;
          }
        }
      });
    },
    getData() {
      let params = {
        electionId: this.electionRelease.id,
        contentType: this.electionRelease.contentType,
      };
      getCandidateList(params).then((res) => {
        if (res.success) {
          this.candidateList = res.result;
        }
      });
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    id() {
      return this.$route.query && this.$route.query.id;
    },
    memberId() {
      return this.$route.query && this.$route.query.memberId;
    },
  },
  mounted() {
    getElectionReleaseInfo({ id: this.id }).then((res) => {
      if (res.success) {
        this.electionRelease = res.result;
        if (this.electionRelease.startTime) {
          setInterval(() => {
            var aaa = new Date(
              this.electionRelease.startTime.replace(/-/g, "/")
            ).getTime();
            var bbb = new Date().getTime();
            let endTime = new Date(
              this.electionRelease.endTime.replace(/-/g, "/")
            ).getTime();
            if (aaa < bbb < endTime) {
              this.countDown = "投票进行中";
            }
            if (endTime < bbb) {
              this.countDown = "投票已经结束";
              return;
            }
            var rightTime = endTime - bbb;
            if (rightTime > 0) {
              var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
              var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
              var mm = Math.floor((rightTime / 1000 / 60) % 60);
              var ss = Math.floor((rightTime / 1000) % 60);
            }
            this.countDown = dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
          }, 1000);
        }
        if (this.electionRelease.content.length > 75) {
          this.isShowMore = true;
        }
        if (this.electionRelease.type == 1) {
          this.minTimes = 1;
          this.maxTimes = 1;
        } else {
          this.minTimes = this.electionRelease.minTimes;
          this.maxTimes = this.electionRelease.maxTimes;
        }
        this.getData();
        this.voteInfoTimesData();
      }
    });
  },
};
</script>

<style lang="less" scoped>
.meeting /deep/.van-nav-bar__title,
.meeting /deep/.van-nav-bar__text {
  color: #000 !important;
}
.meeting /deep/.sign_out {
  color: #000 !important;
}
.voteBox {
  background: #fafafa;
  padding: 20px 4%;
  position: fixed;
  height: 100%;
  overflow-y: scroll;
  width: 92%;
}
.butBox {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  align-items: center;
  margin: 10px 0;
}
.butBox span {
  font-size: 12px;
}
.voteBox ul {
  margin-bottom: 136px;
}
.voteBox > div.voteDiv,
.listRodio {
  border: #ddd solid 1px;
  border-radius: 5px;
  padding: 15px;
  background: #fff;
  margin-bottom: 15px;
}
.voteBox > div.voteDiv h4 {
  color: #000;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.voteBox ul li > div {
  font-size: 12px;
}
.voteBox ul li > div b {
  margin-right: 10px;
}

.m-content {
  font-size: 14px;
  line-height: 20px;
  &.overflow-line {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
.btn-more {
  text-align: center;
  color: #107bdb;
  font-size: 14px;
  margin-top: 10px;
}
.timeDjs {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.listRodio > p {
  font-size: 14px;
  margin-bottom: 10px;
}
</style>
